export { default as Img200 } from './processed/200/Underdog-2007.jpg';
export { default as Img400 } from './processed/400/Underdog-2007.jpg';
export { default as Imgthumb } from './processed/thumb/Underdog-2007.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Underdog-2007.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Underdog-2007.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      180,
      124,
      68
    ],
    "_population": 1,
    "_hsl": [
      0.08333333333333333,
      0.45161290322580644,
      0.4862745098039216
    ]
  },
  "LightVibrant": {
    "_rgb": [
      236,
      221,
      201
    ],
    "_population": 47,
    "_hsl": [
      0.09523809523809525,
      0.4794520547945208,
      0.8568627450980393
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      96,
      68,
      12
    ],
    "_population": 2,
    "_hsl": [
      0.1111111111111111,
      0.7777777777777778,
      0.21176470588235294
    ]
  },
  "Muted": {
    "_rgb": [
      142,
      119,
      95
    ],
    "_population": 2414,
    "_hsl": [
      0.0851063829787234,
      0.19831223628691982,
      0.4647058823529412
    ]
  },
  "LightMuted": {
    "_rgb": [
      199,
      176,
      151
    ],
    "_population": 2592,
    "_hsl": [
      0.08680555555555554,
      0.29999999999999993,
      0.6862745098039216
    ]
  },
  "DarkMuted": {
    "_rgb": [
      91,
      69,
      44
    ],
    "_population": 2599,
    "_hsl": [
      0.08865248226950352,
      0.34814814814814815,
      0.2647058823529412
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Underdog-2007.js